/**
 * Created by synerzip on 07/03/16.
 */
import React from 'react';
import { msToTime } from '../../utils';

class WorkLoggedCell extends React.Component {
    constructor(props) {
        super(props);
        this.elapsedTime = 0;
        this.state = {
            work_millis_logged: this.props.data.work_millis_logged,
            work_millis_target: this.props.data.work_millis_target
        };
    }

    calculateTime() {
        const { work_millis_logged } = this.state;
        return (work_millis_logged || 0) + this.elapsedTime;
    }

    startTimer() {
        if (this.scheduleInterval) {
            return;
        }
        this.scheduleInterval = setInterval(() => {
            this.elapsedTime += 1000;
            this.setState({ timeSpend: this.calculateTime() });
        }, 1000);
    }

    activateTimer() {
        this.elapsedTime = 0;
        this.setState({
            work_millis_logged: this.props.data.work_millis_logged,
            work_millis_target: this.props.data.work_millis_target,
            timeSpend: this.props.data.work_millis_logged || 0
        }, () => {
            this.startTimer();
        });
    }

    componentDidMount() {
        if (this.props.timerActive) {
            this.activateTimer();
        }
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.timerActive && this.props.timerActive) {
            this.activateTimer();
            return;
        }

        const loggedChanged = prevProps.data.work_millis_logged !== this.props.data.work_millis_logged;
        const targetChanged = prevProps.data.work_millis_target !== this.props.data.work_millis_target;

        if (loggedChanged || targetChanged) {
            this.setState({
                work_millis_logged: this.props.data.work_millis_logged,
                work_millis_target: this.props.data.work_millis_target
            });
        }
    }

    componentWillUnmount() {
        if (this.scheduleInterval) {
            clearInterval(this.scheduleInterval);
            this.scheduleInterval = null;
        }
    }

    render() {
        const { timeSpend, work_millis_target, work_millis_logged } = this.state;
        const currentTimeSpend = this.props.timerActive
            ? (timeSpend || this.calculateTime())
            : (work_millis_logged || 0);
        let statusImg = <span> - </span>;

        const targetYellowBoundary = (85 / 100) * work_millis_target;
        if (currentTimeSpend) {
            if (currentTimeSpend < targetYellowBoundary) {
                statusImg = <div style={{ color: '#067809' }}>{msToTime(currentTimeSpend)}</div>;
            } else if (currentTimeSpend >= targetYellowBoundary && currentTimeSpend < work_millis_target) {
                statusImg = <div style={{ color: '#D76800' }}>{msToTime(currentTimeSpend)}</div>;
            } else {
                statusImg = <div style={{ color: '#F52B04' }}>{msToTime(currentTimeSpend)}</div>;
            }
        }

        return (
            <div style={{ fontSize: 36, fontWeight: 'bold' }}>
                {statusImg}
            </div>
        );
    }
}

export default WorkLoggedCell;
